import { useContext } from "react";
import { Grid, Typography, Box, CircularProgress } from "@mui/material";
import { green } from "@mui/material/colors";

import Layout from "../components/Layout/Layout";
import { UserDataContext } from "../app/App";
import { useFetchEmployeeWorkshopOrdersQuery } from "../api";
import WorkshopOrdersList from "../components/WorkshopOrdersList/WorkshopOrdersList";
import ErrorPage from "./ErrorPage";

function MyList() {
    const { user } = useContext(UserDataContext);
    const { data: workshopOrders, isLoading: isLoadingWorkshopOrders, isSuccess: isSuccessWorkshopOrders, isError: isErrorWorkshopOrders } = useFetchEmployeeWorkshopOrdersQuery(user.id);

    if (isLoadingWorkshopOrders) {
        return (
            <Layout color={green[400]} title="My List">
                <Box display="flex" justifyContent="center">
                    <CircularProgress />
                </Box>
            </Layout>
        );
    }

    if (isErrorWorkshopOrders) {
        return <ErrorPage />;
    }

    const totalCount = workshopOrders ? workshopOrders.length : 0;

    return (
        <Layout color={green[400]} title="My List" subtitle={user.name}>
            <Grid container direction="column" spacing={1}>
                <Grid item>
                    <Typography variant="subtitle1">
                        <Typography variant="h5" component="span" color="primary" style={{ fontWeight: "bold", paddingRight: "8px" }}>
                            {totalCount}
                        </Typography>
                        {totalCount === 1 ? "Workshop Order" : "Workshop Orders"}
                    </Typography>
                </Grid>
                <Grid item>{isSuccessWorkshopOrders && workshopOrders && <WorkshopOrdersList orders={workshopOrders} displayVehicle={true} />}</Grid>
            </Grid>
        </Layout>
    );
}

export default MyList;
